import { env } from '@/config/env'

/** 非正式 JWT。HTTP 层见到它会回落到 `VITE_DEV_AUTHORIZATION`。 */
export const DEV_AUTH_SENTINEL = 'dev-mode'

/**
 * 本地联调旁路：显式 `VITE_AUTH_MODE=dev`，或已配置 `VITE_DEV_AUTHORIZATION`。
 * 旁路期间不强制 Hydra，请求仍可用写死的 Bearer / org id。
 */
export function isDevAuthBypass(): boolean {
  return env.authMode === 'dev' || Boolean(env.devAuthorization?.trim())
}
